import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";

const TITLE = "Voorbeeldgalerij templates per paginatype | IT Solutions";
const DESC =
  "Bekijk per paginatype welke template we inzetten: home, diensten, nieuws, regio-landingspagina's, FAQ, portfolio en meer. Onbeperkt pagina's per template.";

import { VoorbeeldenPage } from "@/pages/voorbeelden";

export const Route = createFileRoute("/voorbeelden")({
  head: () =>
    pageHead({ lang: "nl", pathWithoutLang: "/voorbeelden", title: TITLE, description: DESC }),
  component: VoorbeeldenPage,
});
